import { LOGIN_FAILURE, LOGIN_SUCCESS, SIGNOUT, SIGNUP_FAILURE, SIGNUP_SUCCESS } from '../actions/actionTypes';

import { combineReducers } from 'redux';
import { getLocalItem } from '../helpers/localstorage';

const initialState = getLocalItem('login') || { user: null, token: null };

function user(state = initialState.user, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.payload.user;
    case SIGNUP_SUCCESS:
      return action.payload.user;
    case SIGNOUT:
      return null;
    case LOGIN_FAILURE:
      return null;
    case SIGNUP_FAILURE:
      return null;
    default:
      return state;
  }
}

function token(state = initialState.token, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.payload.token;
    case SIGNUP_SUCCESS:
      return action.payload.token;
    case SIGNOUT:
      return null;
    case LOGIN_FAILURE:
      return null;
    case SIGNUP_FAILURE:
      return null;
    default:
      return state;
  }
}

export default combineReducers({ user, token });



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js